import { render, staticRenderFns } from "./arquivoRetorno.vue?vue&type=template&id=2010d753"
import script from "./arquivoRetorno.vue?vue&type=script&lang=js"
export * from "./arquivoRetorno.vue?vue&type=script&lang=js"
import style0 from "./arquivoRetorno.vue?vue&type=style&index=0&id=2010d753&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports